import React from 'react'
import Box from '@mui/material/Box'

const ReleaseRibbon = ({ improved, color }) => (
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      right: 0,
      width: 120,
      height: 120,
      overflow: 'hidden',
      pointerEvents: 'none',
    }}
  >
    <Box
      sx={{
        position: 'absolute',
        top: 18,
        right: -34,
        width: 140,
        textAlign: 'center',
        transform: 'rotate(45deg)',
        bgcolor: color,
        color: 'white',
        py: 0.5,
        fontWeight: 800,
        fontSize: 12,
        letterSpacing: 1,
        boxShadow: 3,
      }}
    >
      {improved ? 'IMPROVED' : 'NEW'}
    </Box>
  </Box>
)

export default ReleaseRibbon
